export function LogoGrayMedium({ ...props }: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='96' height='80' viewBox='0 0 96 80' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g opacity='0.25'>
        <path
          d='M13.923 0C21.2351 0 27.1675 6.01661 27.1675 13.4324V47.993C27.1675 55.4088 21.2351 61.4254 13.923 61.4254C6.61096 61.4254 0.678528 55.4088 0.678528 47.993V13.4324C0.678528 6.01661 6.61096 0 13.923 0Z'
          fill='url(#paint0_linear_2080_38718)'
        />
        <path
          d='M48.0001 18.5746C55.3121 18.5746 61.2445 24.5912 61.2445 32.007V66.5676C61.2445 73.9834 55.3121 80 48.0001 80C40.688 80 34.7556 73.9834 34.7556 66.5676V32.007C34.7556 24.5912 40.688 18.5746 48.0001 18.5746Z'
          fill='url(#paint1_linear_2080_38718)'
        />
        <path
          d='M82.077 1.4342C89.3891 1.4342 95.3215 7.45081 95.3215 14.8666V62.2299C95.3215 69.6458 89.3891 75.6624 82.077 75.6624C74.765 75.6624 68.8325 69.6458 68.8325 62.2299V14.8666C68.8325 7.45081 74.765 1.4342 82.077 1.4342Z'
          fill='url(#paint2_linear_2080_38718)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_2080_38718'
          x1='32.6171'
          y1='-14.202'
          x2='-2.07124'
          y2='66.8821'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6B7280' />
          <stop offset='1' stopColor='#F3F4F6' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_2080_38718'
          x1='66.6941'
          y1='4.33762'
          x2='32.0058'
          y2='85.4217'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4B5563' />
          <stop offset='1' stopColor='#E5E7EB' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_2080_38718'
          x1='96.9426'
          y1='6.43639'
          x2='61.8247'
          y2='80.1789'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#374151' />
          <stop offset='1' stopColor='#D1D5DB' />
        </linearGradient>
      </defs>
    </svg>
  )
}
